<section class="hero">
  <div class="hero__visual">
    <img title="JECRM" src="../../../../../assets/video/jecrm-main.gif" alt="Illustration" class="illustration" />
  </div>
  <div class="hero__content">
    <h1 class="hero__title">
      {{ 'automation_of_sales' | translate }}
    </h1>
    <h2 class="hero__description">
      {{ 'automate_sales_on_platforms' | translate }}
    </h2>
    <div class="hero__buttons">
      <a [title]="'get_started' | translate" [href]="environment.login_url">
        <app-button [title]="'get_started' | translate"></app-button>
      </a>
      <div class="price">
        {{ 'or_with_tariff' | translate }} <span
        class="price__main">{{ pricingService.getPriceInUAH(tariffs?.[0]?.price) }} ₴/<span
        class="to-lower">{{ 'month' | translate }}</span></span><br />
        <span class="price__usd">${{ tariffs?.[0]?.price }}/<span
          class="to-lower">{{ 'month' | translate }}</span></span>
      </div>
    </div>
  </div>
</section>
